export enum ApplicationComponent {
  form = "form",
  crypto = "crypto",
}
